import React, { Component } from "react";
import { getMinutes, getHours } from "./functions";
import { connect } from "react-redux";
import Chart from '../chart'

class List extends Component {
    componentDidMount() {
        this.props.fetch()
    }
    componentWillUnmount() {
        this.props.reset()
    }
    render(){
        const {view} = this.props;
        const {timestamps,nav} = this.props;
        return view === 'graph' 
            ? <Chart /> 
            : timestamps.map( e => <div key={e.ts} className="ts">
                <div>
                    {
                        nav === "daily"
                            ? `${getHours(e.ts)}:${getMinutes(e.ts)} hours ago`
                            : new Date(e.ts).toLocaleDateString('nl-NL', { timeZone: 'UTC' })
                    }
                </div>
                <div>
                    [B]:{e.buyingPrice} {/* <i className={`fa fa-angle-double-${e.buyingPrice > buying ? "down":"up"} fa-2x`}/> */}
                </div>
                <div>
                    [S]:{e.sellingPrice} {/* <i className={`fa fa-angle-double-${e.sellingPrice < selling ? "down":"up"} fa-2x`}/> */}
                </div>
            </div>
        )
    }
}

const mapDispatchToProps = (dispatch, props) => {
    const { timestamps, name } = props
    return {
        fetch: () => dispatch({ type: 'FETCH_ITEM', payload: { timestamps, name } }),
        reset: () => dispatch({ type: 'RESET'})
    };
}

export default connect(null, mapDispatchToProps)(List)


// WEBPACK FOOTER //
// ./src/ui/item/list.js